/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { Box, DefaultThemeProvider, Flex } from '@getgo/chameleon-chakra-ui';
import { GoToHeader } from '../Header/GoToHeader';
import { Footer } from '../Footer/Footer';
import { SessionContext } from '../../context/SessionContext';
import { PageProps } from './Layout';
import { GoToTheme, Spacing } from '../../themes/GoToTheme';

export const GoToLayout: React.FC = ({ children }) => {
  return (
    <DefaultThemeProvider theme={GoToTheme}>
      <Flex
        id='scrollcushion'
        flexDirection='column'
        justifyContent='space-between'
        minWidth='min-content'
      >
        <Flex width='100%'>
          <GoToHeader />
        </Flex>
        <Flex
          justifyContent='flex-start'
          alignItems='stretch'
          flexGrow={1}
          paddingLeft={{ base: Spacing.CoreLayout2, md: Spacing.CoreLayout7 }}
          minWidth='min-content'
        >
          <Flex
            flexDirection='column'
            width={{ base: '100%', md: '60%' }}
            minWidth='min-content'
            paddingRight={{
              base: Spacing.CoreLayout2,
              md: Spacing.CoreLayout4,
            }}
            paddingTop='10%'
            paddingBottom={Spacing.CoreLayout4}
          >
            {children}
          </Flex>
        </Flex>
        <Box
          position='absolute'
          top='0'
          right='0'
          zIndex={-1}
          backgroundImage={`${process.env.PUBLIC_URL}/static/media/background-goto.svg`}
          width='40vw'
          height='100vh'
        />
        <Footer />
      </Flex>
    </DefaultThemeProvider>
  );
};

export const GoToPages: React.FC<PageProps> = ({
  locale,
  translationsForLocale,
  sessionParams,
  children,
}) => (
  <SessionContext.Provider value={sessionParams}>
    <IntlProvider
      locale={locale}
      messages={translationsForLocale}
      textComponent={React.Fragment}
    >
      <GoToLayout>{children}</GoToLayout>
    </IntlProvider>
  </SessionContext.Provider>
);
